export const checkCorrection = (order) =>
	order._ticket?.find(
		(ticket) =>
			ticket.invoice?.correction_number ||
			ticket.valid_invoice?.correction_number,
	);
